"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcalendar = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 52 55",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcalendar` : '') + (description ? ` desc-brandedcalendar` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcalendar"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcalendar"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 17h52v34a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V17Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 5.31h-7V7.7a4 4 0 0 1-8 0V5.3h-8v2.4a4 4 0 0 1-8 0V5.3H3a3 3 0 0 0-3 3V17h52V8.31a3 3 0 0 0-3-3h-4V7.7a4 4 0 0 1-8 0V5.3Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "38.33",
    width: "5.33333",
    height: "10.625",
    rx: "2.66667",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "23.4",
    width: "5.33333",
    height: "10.625",
    rx: "2.66667",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "7.5",
    width: "5.33333",
    height: "10.625",
    rx: "2.66667",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.57 17H42C33.5 34 22.05 46.37 4.25 53.56l-1.25.5h46a3 3 0 0 0 3-3V17h-7.43Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "4",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "4",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "28",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m32.55 37.8-.4.41-.42-.4a2.8 2.8 0 0 0-4.44.7l-.05.11c-.45 1-.26 2.17.48 2.97l4.16 4.3c.14.15.38.15.53 0l4.07-4.22a2.7 2.7 0 0 0 .51-3.15l-.05-.11a2.77 2.77 0 0 0-4.39-.6Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "40",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#1ECAD3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "40",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#1ECAD3"
  }));
};
var _default = exports.default = brandedcalendar;